<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2>Counselling Work Update Details</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="container-fluid">
    <table class="table w-100">
      <tbody>

      <tr>
        <th style="width: 20%; font-weight: bold;">Centre</th>
        <td>
          <ul class="list-unstyled mb-0">
            <li *ngFor="let item of Data.centre">{{ item.centreName }}</li>
          </ul>
        </td>
      </tr>
      <!-- Vehicle Number -->
      <tr>
        <th style="width: 20%; font-weight: bold;">Counsellor</th>
        <td>{{ Data.counsellorName }}</td>
      </tr>

      <tr>
        <th style="width: 20%; font-weight: bold;">Date</th>
        <td>{{ displayDate(Data.date) }}</td>
      </tr>
      <tr>
        <th style="width: 20%; font-weight: bold;">Task</th>
        <td style="white-space: pre-wrap;">{{ Data.task }}</td>
      </tr>
      <tr>
        <th style="width: 20%; font-weight: bold;">Remarks</th>
        <td style="white-space: pre-wrap;">{{ Data.remarks }}</td>
      </tr>

      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="warn">Close</button>
</mat-dialog-actions>
